import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useStoreFilesForRetainerReqest = () => {
    const { scannerBrand, doctorId, modernCode, files, waybillNumber, courierCompany } = useSelector(
        (store) => store.newPatientReducer
    );

    const storeFilesValue = useMemo(() => {
        return {
            scannerBrand,
            doctorId,
            modernCode,
            files: files.filter((f) => f.category === 'stl_file'),
            waybillNumber,
            courierCompany,
        };
    }, [scannerBrand, doctorId, modernCode, files, waybillNumber, courierCompany]);

    const isFileReady = useMemo(() => {
        const { scannerBrand, doctorId, modernCode, files, waybillNumber } = storeFilesValue;
        const isFileValid = files.length > 0 && files.some((f) => f.data && f.dataURL);
        const isScannerBrandValid = scannerBrand.length > 0 && doctorId.length > 0;
        const isCourierValid = modernCode.length > 0;
        if (isFileValid || isScannerBrandValid || isCourierValid) {
            return true;
        }
        return false;
    }, [storeFilesValue]);

    return {
        storeFilesValue,
        isFileReady,
    };
};

export default useStoreFilesForRetainerReqest;
